// (c) chaehongee. Confidential and proprietary.

import { type ReactElement, type ReactNode } from 'react'
import { useAuth } from '../../store/hooks/useAuth'
import { UserMenu } from '../Auth/UserMenu'
import styles from './Sessions.module.css'

type LandingHeaderProps = {
  title: string
  subtitle?: string
  actions?: ReactNode
}

export function LandingHeader({ title, subtitle, actions }: LandingHeaderProps): ReactElement {
  const { user } = useAuth()

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.title}>
          <a href={user ? '/sessions' : '/'} className={styles.titleLink}>{title}</a>
        </h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      <div className={styles.headerActions}>
        {actions}
        <UserMenu />
      </div>
    </header>
  )
}
